import { getMessages } from '../../../../../../store/constants';

export const CARD_TEMPLATES_TITLE = getMessages().getText('aside_panel.tab.card_templates');
export const CLASS_NAME_CARD_TEMPLATES = 'card-templates';
